import {
    Button,
    Flex,
    Image,
    Text,

} from '@chakra-ui/react'
import React, {useEffect, useRef, useState} from 'react'
import { useSearchParams } from 'react-router-dom'
import ReactToPrint from 'react-to-print'
import useApp from '../context/AppContext'


const Player = ({data, play, reserve}) => {

    const {teams,players} = useApp()

    return (
        <Flex
            border={'1px'}
            w={350}
            h={340}
            direction={'column'}
            sx={{
                pageBreakInside: 'avoid'
            }}
        >
            <Flex
                justifyContent={'space-between'}
                px={2}
                pr={10}
                fontWeight={600}
                w={'full'}
                bg={'blue.700'}
                color={'white'}
            >
                <Text>
                    {data?.name}
                </Text>
                <Text>
                    {data?.mid}
                </Text>
            </Flex>

            <Flex
                w={'full'}
                
            >
                <Image src={data?.image}
                    w={"150px"}
                    h={'180px'}
                    border={'1px'}
                />

                <Flex
                    direction={'column'}
                    flex={1}
                    gap={2}
                >

                    <Flex
                        direction={'column'}
                        gap={3}
                        py={1}
                        px={2}
                        fontWeight={500}
                    >

                    <Flex
                        justifyContent={'space-between'}
                        pr={5}
                        position="relative"
                    >

                        <Text>
                            {data?.phone}
                        </Text>

                        <Text
                           position={'absolute'}
                           right={-5}
                           top={0}
                           border={'2px'}
                           p={1}
                           bg={'white'}
                           color={'black'}
                        >
                            {players.players[data.pid].num}
                        </Text>
                    </Flex>
                    
                    <Flex
                        direction={'column'}
                    >

                    <Text>
                    Last Year Stats
                    </Text>
                    <Flex
                        gap={2}
                    >
                        <Text>{data?.score || 0} Runs</Text>
                        <Text>{data?.wickets || 0} Wickets</Text>
                    </Flex>
                    </Flex>

                    <Flex
                wrap={'wrap'}
                gap={2}
                m={'auto'}
            >

                {Object.keys(data?.atts).map(att => (
                    <>
                    {data?.atts[att]?

                        <Text
                            fontSize={'14px'}
                            border={'1px solid'}
                            borderColor={'gray.600'}
                            p={1}
                            borderRadius={10}
                        >
                            {att}
                        </Text>
                        :""
                    }
                    </>
                ))}

            </Flex>


                    </Flex>
                </Flex>
            </Flex>



            
            {reserve?
                <Text
                    w={'full'}
                    textAlign={'center'}
                    bg={'red.700'}
                    color={'white'}
                    minH={25}
                >Reserved by {teams.teams[reserve.tid].name} for {reserve.cost}</Text>:
                play?
                <Text
                    w={'full'}
                    minH={25}
                    textAlign={'center'}
                    bg={'red.700'}
                    color={'white'}
                >Sold to {teams.teams[play.tid].name} for {play.cost}</Text>:
                <Text
                    w={'full'}
                    minH={25}
                    textAlign={'center'}
                    bg={'red.700'}
                    color={'white'}
                >Available</Text>

            }

            <Text
                px={1}
                color={'gray.500'}
                textAlign="center"
            >Notes</Text>
        </Flex>
    )
}


function PrintComponent() {

    let componentRef = useRef()
    const [params] = useSearchParams()
    const {players, soldPlayers, catData, reservedPlayers} = useApp()
    const cat = params.get('cat')
    const [catPlayer, setCatPlayers] = useState([])


    const Header = () => {
        return (
            <Flex
                    bg={"red.700"}
                    direction={'column'}
                    fontSize={'20px'}
                    color={'white'}
                >

                <Text
                    w={'full'}
                    textAlign={'center'}
                    
                    >Category {cat}
                </Text>
                <Flex>
                    <Text
                        
                        w={'full'}
                        textAlign={'center'}
                        
                        >Reserved Price {catData[cat]?.basePrice}
                    </Text>

                    <Text
                        w={'full'}
                        textAlign={'center'}
                        >
                        Choose only {catData[cat]?.limit} Players
                    </Text>
                </Flex>
            </Flex>
        )
    }


    useEffect(() => {

        if(players?.players)
        {
            let plays = []
            players.list.map(key => {
                if(players?.players[key].category === cat)
                {
                    plays.push(players.players[key])
                }
            })
            //plays.sort((a, b) => a.name.localeCompare(b.name));
            setCatPlayers([...plays])
        }

    }, [players, params])


    // const print = () => {

    //     const doc = document.getElementById('print')
    //     html2canvas(doc)
    //     .then(canvas => {
    //         const idata = canvas.toDataURL('image/png')
    //         const pdf = new jspdf.jsPDF()
    //         pdf.addImage(idata, 'JPEG', 0, 0);
    //         pdf.save("d.pdf")
    //     })
    // }




    return (
        <Flex
            direction={'column'}
            p={3}
            gap ={5}
            
        >
            <ReactToPrint
                trigger={() => <Button id={'button'}>Print</Button>}
                content={() => componentRef}
            />
            {/* <Button onClick={() => exportComponentAsPDF(componentRef)}>print</Button> */}


            <Flex 
                ref={el => (componentRef=el)}
                direction={'column'}
                gap={2}
            >
                <Flex
                    justifyContent={'space-evenly'}
                    wrap={'wrap'}
                    rowGap={5}
                    p={2}
                    alignItems="flex-start"
                >

                {catPlayer?.map(p => {
                    
                    const play = soldPlayers?.filter(s => s.pid === p.pid)[0]
                    const reserve = reservedPlayers?.filter(r => r.pid === p.pid)[0]
                    
                    return (
                        <Player data={p} play={play?play:null} reserve={reserve?reserve:null}/>
                    )
                })}
                
                </Flex>
            </Flex>

        </Flex>

    )
}

export default PrintComponent
